/**
 * Auth screen framer-motion variants.
 * Re-exports from theme/motion.js where overlap exists, then adds auth-specific extras.
 * Import from here inside auth pages/components — never from theme/motion directly in auth files.
 */

export {
  pageVariants,
  pageTransition,
  listContainerVariants,
  listItemVariants,
  auroraDrift,
  cardEntrance,
  successPulse,
  fieldShake,
  duration,
  easing,
} from '../../theme/motion';

/** Fade-only variant used for AnimatePresence route cross-fades inside AuthLayout. */
export const routeFade = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.22 } },
  exit: { opacity: 0, transition: { duration: 0.16 } },
};

/** Step transition for multi-step flows (ForgotPassword Step1 → Step2). */
export const stepFade = {
  initial: { opacity: 0, y: 6 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.24, ease: 'easeOut' } },
  exit: { opacity: 0, y: -6, transition: { duration: 0.16 } },
};

/** Stagger container variant for form fields. */
export const formContainer = {
  animate: {
    transition: { staggerChildren: 0.055, delayChildren: 0.12 },
  },
};

/** Individual form field entrance. */
export const formField = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.28, ease: 'easeOut' } },
};

/** Scale-in for OTP verified checkmark. */
export const checkmarkEntrance = {
  initial: { scale: 0, rotate: -90 },
  animate: {
    scale: 1,
    rotate: 0,
    transition: { type: 'spring', stiffness: 260, damping: 20 },
  },
};
